// src/components/layouts/PublicLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import HeaderComponent from '../HeaderComponent'; // Adjust path if needed
import FooterComponent from '../FooterComponent'; // Adjust path if needed

const PublicLayout = () => {
  return (
    <div className="public-layout-wrapper">
      {/* 1. Global Header always stays at the top */}
      <HeaderComponent />

      {/* 2. The Outlet acts as a placeholder where your page content gets injected */}
      <main className="main-content" style={{ minHeight: '80vh' }}>
        <Outlet />
      </main>

      {/* 3. Global Footer always stays at the bottom */}
      <FooterComponent />
    </div>
  );
};

export default PublicLayout;